import { render, staticRenderFns } from "./ProductItemsList.vue?vue&type=template&id=3aca83cd&"
import script from "./ProductItemsList.vue?vue&type=script&lang=js&"
export * from "./ProductItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports